import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    filters: { display: 'flex', alignItems: 'center' },
    filterTitle: { fontSize: 14, fontWeight: 500, color: palette.darkGray },
    divider: {
      borderBottom: `1px solid ${palette.lightGray}`,
      margin: '30px 0px 20px',
    },
    dividerTop: {
      borderBottom: `1px solid ${palette.lightGray}`,
      margin: '10px 0px 20px',
    },
    titleDividers: { fontSize: 16, color: palette.darkGray, fontWeight: 500 },
    iconDividers: {
      fontSize: 16,
      color: palette.darkGray,
      fontWeight: 500,
      marginRight: 6,
    },
    costsSection: {
      border: `2px solid ${palette.deepBlue}`,
      borderRadius: 8,
      padding: 16,
    },
    alert: {
      maxWidth: 800,
      margin: '0 auto',
    },
    filtersContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4px',
      marginLeft: 20,
      height: '100%',
    },
    dividerFilters: {
      backgroundColor: palette.lightGray,
      margin: '0 0 0 15px',
    },
  });
